(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const mainImage = section.querySelector('[data-gallery-main]');
    section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => { mainImage.src = thumb.dataset.image; section.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active')); thumb.classList.add('is-active'); }));
    const idInput = section.querySelector('[data-variant-id]'); const price = section.querySelector('[data-product-price]'); const compare = section.querySelector('[data-product-compare]'); const buttonPrice = section.querySelector('[data-button-price]'); const submit = section.querySelector('.product-submit'); const submitLabel = section.querySelector('[data-submit-label]'); const toggle = section.querySelector('[data-subscription-toggle]'); const planInput = section.querySelector('[data-selling-plan-input]');
    section.querySelectorAll('[data-variant-card]').forEach((card) => card.addEventListener('click', () => { section.querySelectorAll('[data-variant-card]').forEach((item) => item.classList.remove('is-active')); card.classList.add('is-active'); idInput.value = card.dataset.variantId; price.textContent = card.dataset.price; buttonPrice.textContent = card.dataset.price; compare.textContent = card.dataset.compare; compare.hidden = !card.dataset.compare; const available = card.dataset.available === 'true'; submit.disabled = !available; submitLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT'; toggle.disabled = !card.dataset.sellingPlan; toggle.checked = false; planInput.disabled = true; planInput.value = ''; }));
    toggle.addEventListener('change', () => { const card = section.querySelector('[data-variant-card].is-active'); planInput.value = card ? card.dataset.sellingPlan : ''; planInput.disabled = !toggle.checked || !planInput.value; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach((timer) => {
    let remaining = Number(timer.dataset.countdown || 2) * 3600;
    const render = () => {
      remaining = remaining > 0 ? remaining - 1 : Number(timer.dataset.countdown || 2) * 3600;
      timer.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      timer.querySelector('[data-minutes]').textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
      timer.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
    };
    render(); setInterval(render, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvera-cart-drawer"]) return;
  try {
    
  if (!customElements.get('solvera-cart')) customElements.define('solvera-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.root = this.dataset.root;
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('drawer-open');
        if (this.opener?.isConnected) this.opener.focus();
      });
      this.addEventListener('click', event => {
        if (event.target === this.dialog || event.target.closest('[data-scd-close]')) return this.dialog.close();
        const button = event.target.closest('[data-scd-quantity],[data-scd-upgrade]');
        if (!button || this.busy) return;
        const key = button.closest('[data-line]').dataset.line;
        this.run(async () => {
          if (button.hasAttribute('data-scd-upgrade')) await this.upgrade(key, Number(button.dataset.scdUpgrade));
          else await this.change(key, Number(button.dataset.scdQuantity));
          await this.refresh();
        });
      });
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== (this.root + 'cart').replace(/\/$/, '') || url.search) return;
        event.preventDefault();
        this.open(link);
        this.run(() => this.refresh());
      });
      document.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('form[action*="/cart/add"]')) return;
        event.preventDefault();
        if (this.busy) return;
        this.open(event.submitter);
        this.run(async () => {
          const body = new FormData(form);
          body.delete('solvera_bundle');
          body.set('sections', this.dataset.section);
          body.set('sections_url', location.pathname);
          const data = await this.request('cart/add.js', {method:'POST', body});
          if (!this.render(data.sections?.[this.dataset.section])) await this.refresh();
        });
      });
    }
    open(opener) {
      this.opener = opener || document.activeElement;
      if (!this.dialog.open) this.dialog.showModal();
      document.body.classList.add('drawer-open');
    }
    async request(path, options = {}) {
      const response = await fetch(this.root + path, {...options, headers:{Accept:'application/json', ...options.headers}});
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || this.dataset.error);
      return data;
    }
    async change(key, quantity) {
      return this.request('cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key,quantity})});
    }
    async refresh() {
      const response = await fetch(`${this.root}?sections=${encodeURIComponent(this.dataset.section)}`, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(this.dataset.error);
      const sections = await response.json();
      if (!this.render(sections[this.dataset.section])) throw new Error(this.dataset.error);
    }
    render(html) {
      if (!html) return false;
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-scd-content]');
      if (!content) return false;
      const previous = this.querySelector('[data-scd-content]');
      const scroll = previous.querySelector('.scd-scroll')?.scrollTop || 0;
      previous.replaceWith(content);
      if (content.querySelector('.scd-scroll')) content.querySelector('.scd-scroll').scrollTop = scroll;
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        bubble.hidden = Number(content.dataset.count) === 0;
        const count = bubble.querySelector('[aria-hidden="true"]');
        if (count) count.textContent = content.dataset.count;
      });
      return true;
    }
    async upgrade(key, variantId) {
      const cart = await this.request('cart.js');
      const old = cart.items.find(item => item.key === key);
      if (!old) throw new Error(this.dataset.error);
      const item = {id:variantId,quantity:old.quantity,properties:old.properties};
      const plan = old.selling_plan_allocation?.selling_plan?.id;
      if (plan) item.selling_plan = plan;
      const added = await this.request('cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})});
      try { await this.change(key, 0); }
      catch (error) {
        const newLine = added.items[0];
        await this.change(newLine.key, Math.max(0, newLine.quantity - old.quantity));
        throw error;
      }
    }
    async run(action) {
      if (this.busy) return;
      this.busy = true;
      const alert = this.querySelector('.scd-error');
      alert.hidden = true;
      const disable = () => this.querySelectorAll('button:not([data-scd-close])').forEach(button => button.disabled = true);
      disable();
      this.dialog.setAttribute('aria-busy','true');
      try { await action(); }
      catch (error) {
        alert.textContent = error.message || this.dataset.error;
        alert.hidden = false;
        try { await this.refresh(); } catch {}
      }
      finally {
        this.busy = false;
        this.dialog.removeAttribute('aria-busy');
        this.querySelectorAll('button').forEach(button => button.disabled = false);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
